import { render } from "./DeleteConfirmationDialog.vue?vue&type=template&id=2ff40148&scoped=true"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=js"

import "./DeleteConfirmationDialog.vue?vue&type=style&index=0&id=2ff40148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff40148"]])

export default __exports__